(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-left-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  class MVPTabsController {
    constructor(sectionId) {
      this.section = document.getElementById(sectionId);
      if (!this.section) return;

      this.mainImage = this.section.querySelector('.left-image-container img');
      this.defaultImageUrl = this.mainImage ? this.mainImage.src : '';

      // Gather all the buttons (desktop + mobile)
      this.buttons = this.section.querySelectorAll('.left-cut-button');

      this.init();
    }

    init() {
      // Add event listeners for click/hover
      this.buttons.forEach(button => {
        button.addEventListener('click', (e) => this.handleClick(e, button));
        button.addEventListener('mouseover', () => this.handleHover(button));
        button.addEventListener('mouseout', () => this.handleMouseOut());
      });
    }

    handleClick(event, button) {
      event.preventDefault();
      const idx = button.getAttribute('data-index');

      // Deactivate all buttons
      this.buttons.forEach(b => b.classList.remove('active'));

      // Activate the group of matching data-index
      this.section
        .querySelectorAll(`.left-cut-button[data-index="${idx}"]`)
        .forEach(b => b.classList.add('active'));

      // Change main image
      this.setMainImage(button.getAttribute('data-image'));
    }

    handleHover(button) {
      // On hover, change image to hovered button's image
      this.setMainImage(button.getAttribute('data-image'));
    }

    handleMouseOut() {
      // On mouse out, revert to the currently active button (if any)
      const activeBtn = this.section.querySelector('.left-cut-button.active');
      const newSrc = activeBtn
        ? activeBtn.getAttribute('data-image')
        : this.defaultImageUrl;
      this.setMainImage(newSrc);
    }

    setMainImage(url) {
      if (!this.mainImage || !url || this.mainImage.src === url) return;

      // Fade out
      this.mainImage.style.opacity = '0';

      // Preload the new image
      const temp = new Image();
      temp.onload = () => {
        this.mainImage.src = url;
        this.mainImage.style.opacity = '1';
      };
      temp.onerror = () => {
        console.error('Image failed:', url);
        this.mainImage.src = this.defaultImageUrl;
        this.mainImage.style.opacity = '1';
      };
      temp.src = url;
    }
  }

  // Initialize controller for each matching section
  document.querySelectorAll('[id^="mvp-tabs-"]').forEach(sec => {
    new MVPTabsController(sec.id);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-with-image"] && !Shopify.designMode) return;
  try {
    
// Hover effect for certification logos
document.querySelectorAll('.certification-item img').forEach(img => {
  img.addEventListener('mouseover', () => {
    img.style.transform = 'scale(1.1)';
  });
  img.addEventListener('mouseout', () => {
    img.style.transform = 'scale(1)';
  });
});

  } catch(e) { console.error(e); }
})();
})();
